<atn-ds-widget title="General">
  <div class="atn-scenario-general-tab">
    <div
      class="atn-scenario-general-tab__field"
      data-test-id="name-field"
    >
      <span><b>Name</b></span>
      <atn-ds-value [value]="scenarioNameSg()" />
    </div>
    <div
      class="atn-scenario-general-tab__field"
      data-test-id="alias-field"
    >
      <span><b>Alias</b></span>
      <atn-ds-value [value]="scenarioAliasSg()" />
    </div>
    <div
      class="atn-scenario-general-tab__field"
      data-test-id="description-field"
    >
      <span><b>Description</b></span>
      <atn-ds-value [value]="scenarioDescriptionSg()" />
    </div>
    <div
      class="atn-scenario-general-tab__field"
      data-test-id="active-period-field"
    >
      <span><b>Active Period</b></span>
      <atn-ds-value
        [value]="scenarioPeriodSg()"
        [valueInfo]="periodValueInfo"
      />
    </div>
  </div>
</atn-ds-widget>
